<template>
  <div class="darkbg" @click="emit('closeCart')"></div>
  <div class="box cart-panel">
    <div class="cart-header">
      <div class="cart-header-left">
        <span class="cart-title">Cart</span>
      </div>
      <div class="cart-header-right" @click="emit('closeCart')">
        <img src="/images/close.png" style="width: 19px; height: 19px; object-fit: cover" />
      </div>
    </div>
    <div class="empty-body">
      <div class="empty-icon">
        <IcShoppingCart />
      </div>
      <p class="empty-heading">Your cart is empty</p>
      <p class="empty-sub">Start exploring and add something exciting to your trip.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{ closeCart: [] }>()
</script>

<style scoped lang="scss">
.darkbg {
  position: fixed;
  inset: 0;
  z-index: 9999998;

  @media (max-width: 751px) {
    height: calc(100% - var(--mobile-nav-height, 0px));
  }
}

.box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  width: 480px;
  max-width: calc(100vw - 32px);
  height: auto;
  box-sizing: border-box;
  box-shadow: 0px 8px 32px 0px rgba(18, 23, 70, 0.16);
  border-radius: 12px;
  z-index: 99999999;
  overflow-y: auto;
  font-size: 16px;

  @media (max-width: 751px) {
    top: auto;
    bottom: calc(var(--mobile-nav-height, 0px) + 16px);
    left: 16px;
    right: 16px;
    transform: none;
    width: auto;
    max-width: none;
  }
}

.cart-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  background: #4f6f52;
  border-radius: 12px 12px 0 0;
  padding: 0 16px;

  .cart-header-left {
    flex: 1;
    display: flex;
    align-items: center;
  }

  .cart-title {
    font-size: 17px;
    color: white;
  }

  .cart-header-right {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}

.empty-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 12px;
}

.empty-icon {
  font-size: 80px;
  color: #cccccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-heading {
  font-size: 18px;
  font-weight: 700;
  color: #222222;
  margin: 0;
}

.empty-sub {
  font-size: 14px;
  color: #666666;
  margin: 0;
  text-align: center;
  line-height: 1.5;
}
</style>
